// src/App.js - VERSIONE COMPLETA E CORRETTA CON USER CONTEXT

import React, { useState, useEffect, Fragment, useRef } from 'react'; // Assicurati di importare useRef
import { Routes, Route, NavLink, Navigate, useNavigate } from 'react-router-dom';
import { navStructure } from './appConfig';
import { UserProvider, useUser } from './UserContext';
import { BillingProvider, useBilling } from './context/BillingContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ShiftsPage from './ShiftsPage';
import ProceduresPage from './ProceduresPage';
import LoginPage from './LoginPage';
import { auth, db, messaging } from './firebase';
import { signOut } from "firebase/auth";
import RoomsPage from './RoomsPage';
import ManageStaff from './ManageStaff';
import ProtectedRoute from './ProtectedRoute';
import Dashboard from './Dashboard';
import NotificationsPanel from './NotificationsPanel';
import { collection, query, where, onSnapshot, orderBy, limit } from 'firebase/firestore'; 
import ManageInventory from './ManageInventory';
import { ForcePasswordChangeModal } from './ForcePasswordChangeModal';
import LeaveManagementPage from './LeaveManagementPage';
import ManageContractProfiles from './ManageContractProfiles';
import { onMessage } from "firebase/messaging";
import StickyNotesPanel from './StickyNotesPanel'; // Importa il nuovo componente
import './StickyNotesPanel.css';
import CalendarPage from './CalendarPage';
import CalendarPanel from './CalendarPanel';
import TimesheetView from './TimesheetView';
import PayrollDashboard from './PayrollDashboard';
import PayslipPage from './PayslipPage';
import RegisterPage from './RegisterPage';
import ManageCenter from './ManageCenter';
import ExpenseNotesPage from './ExpenseNotesPage';
import ShiftRulesPage from './ShiftRulesPage';
import ReportsPage from './ReportsPage'; // NUOVO IMPORT
import Announcements from './Announcements'; // NUOVO IMPORT
import SubscriptionBanner from './components/SubscriptionBanner';
import AdminDashboard from './AdminDashboard';
import ActivityLog from './ActivityLog';
import AuraCopilotWidget from './AuraCopilotWidget';
import MyCompensations from './MyCompensations';
import ManageDoctors from './ManageDoctors';

const mobileLinkCompactStyles = `
    @media (max-width: 768px) {
        .main-nav-container { 
            padding: 10px 5px !important;
            gap: 5px !important;
            flex-wrap: wrap !important; /* MODIFICATO: Permette ai link di andare a capo */
            justify-content: center !important; /* Allinea a sinistra quando vanno a capo */
            /* Rimuoviamo overflow-x che non serve più e causava problemi */
        }

        .nav-link-item { 
            font-size: 0.7rem !important;
            padding: 6px 8px !important;
            white-space: nowrap;
            display: flex;
            align-items: center;
            height: 35px;
        }

        .main-nav-container > div:last-child button,
        .main-nav-container > button:last-child {
            transform: scale(0.85);
        }
    }
`;

// --- SOSTITUISCI IL TUO COMPONENTE MobileMenu CON QUESTO ---
const MobileMenu = ({ userProfile, activeCenterId, availableCenters, switchCenter, onClose }) => {
    const [isCenterAccordionOpen, setIsCenterAccordionOpen] = useState(false); 
    const isSuperAdmin = userProfile?.role === 'Super Admin';
    const centerManagementPermitted = userProfile?.permissions?.centerManagement === 'completo';
    const showCenterManagementLink = centerManagementPermitted || isSuperAdmin;

    // --- INIZIO LOGICA PAGINAZIONE ---
    const [currentPage, setCurrentPage] = useState(0);
    const ITEMS_PER_PAGE = 2; // Quanti centri mostrare per pagina

    const centerIds = Object.keys(availableCenters);
    const totalPages = Math.ceil(centerIds.length / ITEMS_PER_PAGE);

    // Calcola i centri da mostrare nella pagina corrente
    const paginatedCenterIds = centerIds.slice(
      currentPage * ITEMS_PER_PAGE,
      (currentPage + 1) * ITEMS_PER_PAGE
    );
    // --- FINE LOGICA PAGINAZIONE ---
    const getPerm = (key) => (userProfile.permissions || {})[key] || 'none';
    // Funzione helper per trovare i permessi
   
    
    return (
        <div className="mobile-menu-overlay" onMouseDown={onClose}>
            <div className="mobile-menu-panel" onMouseDown={e => e.stopPropagation()}>
                <div className="mobile-menu-header">
                    <h3>Menu</h3>
                    <button onClick={onClose} className="close-menu-btn">✖</button>
                </div>

                {/* ⭐ BLOCCO UNIFICATO UTENTE/CENTRO (ACCORDION) ⭐ */}
                <div className="mobile-menu-center-accordion">
                     <div 
                         className={`user-info-area ${isCenterAccordionOpen ? 'active-user-area' : ''}`}
                         onClick={() => setIsCenterAccordionOpen(p => !p)} 
                     >
                          <p className="user-name-mobile-display">{userProfile.name}</p>
                          <p className="user-role-mobile-display">Ruolo: {userProfile.role || 'N/D'} {isCenterAccordionOpen ? '▲' : '▼'}</p>
                     </div>
                     
                     <div className={`center-switch-area-content ${isCenterAccordionOpen ? 'open' : ''}`}>
                          {centerIds.length > 1 && (
                              <>
                                  <h4 className="mobile-menu-sub-title">CAMBIA CENTRO</h4>
                                  
                                  {/* --- LISTA PAGINATA --- */}
                                  <div className="center-switch-list">
                                      {paginatedCenterIds.map(centerId => ( // Usa la lista paginata
                                          <button 
                                              key={centerId}
                                              className={`center-switch-button ${centerId === activeCenterId ? 'active' : ''}`}
                                              onClick={() => {
                                                  switchCenter(centerId);
                                                  onClose(); 
                                              }}
                                          >
                                              {centerId.replace(/-/g, ' ')}
                                              {centerId === activeCenterId && ' (Attivo)'}
                                          </button>
                                      ))}
                                  </div>

                                  {/* --- CONTROLLI PAGINAZIONE (Mostra solo se ci sono più pagine) --- */}
                                  {totalPages > 1 && (
                                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px', color: 'white' }}>
                                          <button 
                                              onClick={(e) => { e.stopPropagation(); setCurrentPage(p => p - 1); }} 
                                              disabled={currentPage === 0}
                                              style={{ background: 'rgba(255,255,255,0.2)', border: 'none', color: 'white', padding: '6px 12px', borderRadius: '5px', cursor: 'pointer', opacity: currentPage === 0 ? 0.4 : 1 }}
                                          >
                                              ←
                                          </button>
                                          <span style={{ fontSize: '0.8rem' }}>Pagina {currentPage + 1} di {totalPages}</span>
                                          <button 
                                              onClick={(e) => { e.stopPropagation(); setCurrentPage(p => p + 1); }} 
                                              disabled={currentPage === totalPages - 1}
                                              style={{ background: 'rgba(255,255,255,0.2)', border: 'none', color: 'white', padding: '6px 12px', borderRadius: '5px', cursor: 'pointer', opacity: currentPage === totalPages - 1 ? 0.4 : 1 }}
                                          >
                                              →
                                          </button>
                                      </div>
                                  )}
                              </>
                          )}
                     </div>
                </div>
                {/* ⭐ FINE BLOCCO ACCORDION ⭐ */}
                
                <nav className="main-mobile-nav-list"> 
                    {navStructure.map(item => {
                        // --- Gestione Link Singolo (NON E' UN DROPDOWN) ---
                        if (item.type === 'link') {
                            // --- INIZIO MODIFICA: Permesso 'shiftRules' ---
                            let perm = userProfile.permissions[item.key] || 'none';
                            let canView = perm !== 'none';
                            
                            // 🎯 FIX MEDICI: Nascondi voci vietate, forza la visione di stanze e compensi
                            if (userProfile.isDoctorProfile) {
                                if (['shifts', 'timelogs', 'leaves', 'payslips', 'payroll', 'staff', 'centerManagement', 'procedures'].includes(item.key)) return null;
                                if (item.key === 'rooms' || item.key === 'myCompensations') canView = true;
                            }

                            if (item.key === 'payroll') {
                                canView = perm === 'completo' || perm === 'semi-completo';
                            }
                            if (item.key === 'shiftRules') {
                                // Lega questo permesso a chi può modificare i turni
                                const shiftPerm = userProfile.permissions['shifts'] || 'none';
                                canView = shiftPerm === 'completo' || shiftPerm === 'semi-completo';
                            }
                            // --- FINE MODIFICA ---

                            if (!canView) return null;
                            
                            return (
                                <NavLink key={item.key} to={item.path} className="mobile-menu-link" onClick={onClose}>
                                    {item.label}
                                </NavLink>
                            );
                        }
                        
                        // --- Gestione Dropdown ---
                        if (item.type === 'dropdown') {
                            
                            // 🎯 FIX CHIRURGICO MEDICI: Uccidiamo l'intero menù Gestione alla radice
                            if (userProfile?.isDoctorProfile) return null;

                            const staffLink = item.subItems.find(sub => sub.key === 'staff');
                            // ⭐️⭐️⭐️ INIZIO CORREZIONE ⭐️⭐️⭐️
                            const centerManagementLink = item.subItems.find(sub => sub.key === 'centerManagement'); 
                            // ⭐️⭐️⭐️ FINE CORREZIONE ⭐️⭐️⭐️
                            const shiftRulesLink = item.subItems.find(sub => sub.key === 'shiftRules');
                            
                            const filteredSubItems = item.subItems.filter(sub => 
                                sub.key !== 'centerManagement' && 
                                sub.key !== 'staff' &&
                                sub.key !== 'shiftRules' // Escludi anche questo
                            );
                            
                            // Logica permessi per 'shiftRules' (leghiamolo a 'shifts')
                            const shiftRulesPerm = userProfile.permissions['shifts'] || 'none';
                            const canViewShiftRules = shiftRulesPerm === 'completo' || shiftRulesPerm === 'semi-completo';

                            // --- CORREZIONE QUI ---
                            // Assicurati che centerManagementLink sia definito prima di usarlo
                            const centerManagementPerm = centerManagementLink ? getPerm(centerManagementLink.key) : 'none';
                            const canViewCenterManagement = centerManagementPerm !== 'none';

                            const canViewAnySubItem = filteredSubItems.some(sub => {
                                const subPerm = userProfile.permissions[sub.key] || 'none';
                                if (sub.key === 'payroll') {
                                    return subPerm === 'completo' || subPerm === 'semi-completo';
                                }
                                return subPerm !== 'none';
                            }) || getPerm(staffLink?.key) !== 'none' 
                               || canViewCenterManagement // Usa la variabile sicura
                               || canViewShiftRules; 
                            // --- FINE CORREZIONE ---


                            if (!canViewAnySubItem) return null;

                            return (
                                <Fragment key={item.key}>
                                    {/* Titolo per il gruppo nel menu mobile */}
                                    <h4 className="mobile-menu-group-title">{item.label.replace(' ▾', '')}</h4>
                                    
                                    {/* 1. Renderizza i link principali del dropdown (Timbrature, Assenze, Paghe, Buste Paga) */}
                                    {filteredSubItems.map(subItem => {
                                        const subPerm = getPerm(subItem.key);
                                        let canViewSub = subPerm !== 'none';
                                        if (subItem.key === 'payroll') {
                                            canViewSub = subPerm === 'completo' || subPerm === 'semi-completo';
                                        }

                                        // 🎯 FIX MEDICI: Nascondi sottomenù vietati, mostra stanze
                                        if (userProfile.isDoctorProfile) {
                                            if (['shifts', 'timelogs', 'leaves', 'payslips', 'payroll', 'staff', 'centerManagement', 'procedures'].includes(subItem.key)) return null;
                                            if (subItem.key === 'rooms') canViewSub = true;
                                        }

                                        if (!canViewSub) return null;

                                        return (
                                            <NavLink key={subItem.key} to={subItem.path} className="mobile-menu-link" onClick={onClose}>
                                                {/* Applica indentazione standard (15px) per i link interni */}
                                                <span style={{ paddingLeft: '15px' }}>{subItem.label}</span>
                                            </NavLink>
                                        );
                                    })}
                                    
                                    {/* 2. Renderizza GESTIONE PERSONALE (Base) */}
                                    {staffLink && getPerm(staffLink.key) !== 'none' && (
                                        <NavLink key={staffLink.key} to={staffLink.path} className="mobile-menu-link" onClick={onClose}>
                                            {/* Applica indentazione standard (15px) */}
                                            <span style={{ paddingLeft: '15px' }}>{staffLink.label}</span>
                                        </NavLink>
                                    )}
                                    
                                    {/* 3. Renderizza Impostazioni Turni */}
                                    {shiftRulesLink && canViewShiftRules && (
                                        <NavLink key={shiftRulesLink.key} to={shiftRulesLink.path} className="mobile-menu-link" onClick={onClose}>
                                            <span style={{ paddingLeft: '15px' }}>{shiftRulesLink.label}</span>
                                        </NavLink>
                                    )}
                                    
                                    {/* 4. Renderizza GESTIONE CENTRO (con forte indentazione 30px) */}
                                    {centerManagementLink && canViewCenterManagement && ( // Usa la variabile sicura
                                        <NavLink key={centerManagementLink.key} to={centerManagementLink.path} className="mobile-menu-link" onClick={onClose}>
                                            <span style={{ paddingLeft: '15px' }}>{centerManagementLink.label}</span> 
                                        </NavLink>
                                    )}
                                </Fragment>
                            );
                        }
                        return null;
                    })}
                </nav>
            </div>
        </div>
    );
};

const navStyles = {
    position: 'sticky',
    top: 0,
    zIndex: 1010,
    // Il layout (padding, gap, align, justify, display)
    // è ora gestito dal file CSS.
};

const navLinkStyle = {
    textDecoration: 'none',
    color: 'black',
    padding: '8px 15px',
    borderRadius: '5px',
    fontWeight: '500',
    transition: 'all 0.2s',
};

const activeNavLinkStyle = {
    backgroundColor: '#4a90e2',
    color: 'white',
};

const logoutButtonStyle = {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
};
const notificationButtonStyle = {
    position: 'relative',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: 'white',
    fontSize: '1.5rem',
    padding: '0 10px'
};

const unreadBadgeStyle = {
    position: 'absolute',
    top: '-5px',
    right: '0px',
    background: '#d0021b',
    color: 'white',
    borderRadius: '50%',
    width: '18px',
    height: '18px',
    fontSize: '0.7rem',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
};
const notificationWrapperStyle = {
    position: 'relative', // Questo è il contenitore che ancora il pannello
    marginLeft: '15px', // Un po' di spazio a sinistra
};
const userNameStyle = {
        color: '#f2f2f2',
        fontWeight: 'bold',
        fontSize: '0.9rem',
        whiteSpace: 'nowrap', // Impedisce al nome di andare a capo
        overflow: 'hidden',   // Nasconde se troppo lungo
        textOverflow: 'ellipsis' // Aggiunge puntini se troppo lungo
    };
    
// 👇 INIZIALIZZA IL CLIENT DI REACT QUERY (Cache condivisa)
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // I dati restano "freschi" per 5 minuti
      refetchOnWindowFocus: false, // Evita chiamate a Firebase se l'admin cambia scheda
      retry: 1,
    },
  },
});

// Questo componente interno gestisce la logica di visualizzazione
function AppContent() {
    // --- RECUPERIAMO I NUOVI DATI DAL CONTEXT ---
    const { 
        userProfile, loading, forcePasswordChange, passwordChanged, 
        activeCenterId, availableCenters, switchCenter, addCenterToContext 
    } = useUser();
    const { isSuspended, isPastDue } = useBilling();
    const [isPanelOpen, setIsPanelOpen] = useState(false);
    const [notifications, setNotifications] = useState([]);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isStickyNotesOpen, setIsStickyNotesOpen] = useState(false);
    const [isCalendarPanelOpen, setIsCalendarPanelOpen] = useState(false);
    const navigate = useNavigate();
    // --- NUOVA LOGICA PER DROPDOWN DESKTOP ---
    const [openDropdown, setOpenDropdown] = useState(null); // Salva la key del dropdown aperto
    const navRef = useRef(null); // Ref per il contenitore della nav

    // Aggiungi un listener per chiudere il dropdown se si clicca fuori
    useEffect(() => {
    const handleClickOutside = (event) => {
        if (navRef.current && !navRef.current.contains(event.target)) {
            setOpenDropdown(null); // Chiudi qualsiasi dropdown aperto
        }
    };
    // *** RIMETTI 'click' ***
    document.addEventListener('click', handleClickOutside); 
    return () => {
        // *** RIMETTI 'click' ***
        document.removeEventListener('click', handleClickOutside); 
    };
}, []); // L'array vuoto è corretto
    // --- FINE NUOVA LOGICA DROPDOWN ---

    useEffect(() => {
        if (userProfile) {
            // L'istanza 'messaging' è ora importata direttamente da firebase.js
            
            const unsubscribe = onMessage(messaging, (payload) => {
                console.log('Messaggio ricevuto in primo piano:', payload);

                // Estraiamo i dati per la notifica
                const notificationTitle = payload.data.title;
                const notificationOptions = {
                    body: payload.data.body,
                    icon: '/logo192.png' // Puoi usare l'icona che preferisci
                };

                // Usiamo l'API nativa del browser per mostrare la notifica
                // Questo simula esattamente ciò che fa il service worker in background
                new Notification(notificationTitle, notificationOptions);
            });

            return () => unsubscribe();
        }
    }, [userProfile]);
    
    useEffect(() => {
        if (!userProfile) return;
        // Assicurati che il centerId sia attivo prima di fare la query
        if (!activeCenterId) return; 
        
        const q = query(collection(db, "notifications"), where("recipientId", "==", userProfile.uid), orderBy("timestamp", "desc"), limit(20));
        const unsubscribe = onSnapshot(q, (snapshot) => {
            setNotifications(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        });
        return () => unsubscribe();
    }, [userProfile, activeCenterId]);

    const handleLogout = async () => {
        try { 
            await signOut(auth); 
            navigate('/', { replace: true }); // 🎯 FIX: Pulisce l'URL e riporta alla pagina di base
        } catch (error) { console.error("Errore logout:", error); }
    };

    if (loading) {
        return <div style={{ textAlign: 'center', paddingTop: '50px' }}>Caricamento...</div>;
    }

    // 2. SE NON C'E' UTENTE, mostra solo le rotte pubbliche
    if (!userProfile) {
        return (
            <Routes>
                <Route path="/register" element={<RegisterPage />} />
                <Route path="*" element={<LoginPage />} /> 
            </Routes>
        );
    }
    
    // 3. SE C'E' UTENTE, ma deve cambiare password
    if (forcePasswordChange) {
        return <ForcePasswordChangeModal onPasswordChanged={passwordChanged} />;
    }

    // 3bis. SE IL CENTRO È SOSPESO, blocca l'accesso
    if (isSuspended) {
        return (
            <div style={{
                minHeight: "100vh", display: "flex", flexDirection: "column",
                justifyContent: "center", alignItems: "center",
                backgroundColor: "#fef2f2", padding: "40px 20px", textAlign: "center",
            }}>
                <div style={{
                    backgroundColor: "white", borderRadius: "20px", padding: "40px",
                    maxWidth: "480px", width: "100%",
                    boxShadow: "0 10px 25px rgba(0,0,0,0.1)", border: "1px solid #fca5a5",
                }}>
                    <div style={{
                        width: "64px", height: "64px", borderRadius: "50%",
                        backgroundColor: "#fee2e2", display: "flex",
                        alignItems: "center", justifyContent: "center",
                        margin: "0 auto 20px", fontSize: "2rem",
                    }}>⛔</div>
                    <h1 style={{ fontSize: "1.4rem", color: "#991b1b", margin: "0 0 10px", fontWeight: "700" }}>
                        Servizio Sospeso
                    </h1>
                    <p style={{ color: "#7f1d1d", fontSize: "0.95rem", lineHeight: "1.6", margin: "0 0 24px" }}>
                        L'abbonamento di questo centro è stato sospeso per mancato pagamento.
                        I dati sono al sicuro e verranno conservati.
                    </p>
                    <p style={{ color: "#9ca3af", fontSize: "0.85rem", margin: "0 0 24px" }}>
                        Per riattivare il servizio, aggiorna il metodo di pagamento
                        oppure contatta <b>privacy@auramedical.club</b>.
                    </p>
                    <SubscriptionBanner />
                </div>
            </div>
        );
    }

    // 4. SE C'E' UTENTE ed è tutto OK, mostra l'app
    const unreadCount = notifications.filter(n => !n.isRead).length;
    
    // Altrimenti, mostriamo la normale applicazione.
     return (
        <div style={{ paddingBottom: '20px' }}>
            {isPastDue && (
                <div style={{ maxWidth: "1200px", margin: "10px auto 0", padding: "0 20px" }}>
                    <SubscriptionBanner />
                </div>
            )}
            {isMobileMenuOpen && (
                 <MobileMenu 
                     userProfile={userProfile} 
                     activeCenterId={activeCenterId} 
                     availableCenters={availableCenters} 
                     switchCenter={switchCenter} 
                     onClose={() => setIsMobileMenuOpen(false)} 
                 />
            )}
            
            {/* --- MODIFICA: Aggiunto ref={navRef} --- */}
            <nav style={navStyles} className="main-nav-container" ref={navRef}>
                <div className="nav-desktop-wrapper">
                
                    {/* --- INIZIO NUOVO MENU UTENTE (sostituisce nav-left-group) --- */}
                    <div className="nav-left-group" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                        
                        <div className="nav-dropdown"> {/* Riutilizziamo lo stile dropdown */}
                            
                            {/* Questo è il pulsante che clicchi (il tuo nome) */}
                            <button
                                className="dropdown-button" 
                                style={openDropdown === 'userMenu' ? { ...navLinkStyle, ...activeNavLinkStyle } : navLinkStyle}
                                onPointerDown={(e) => {
                                    e.stopPropagation();
                                    setOpenDropdown(openDropdown === 'userMenu' ? null : 'userMenu');
                                }}
                            >
                                {userProfile.name} 
                                {/* Mostra il nome del centro attivo accanto al nome */}
                                <span style={{fontSize: '0.8rem', opacity: 0.7, marginLeft: '8px'}}>
                                    ({activeCenterId.replace(/-/g, ' ')}) ▾
                                </span>
                            </button>

                            {/* Questo è il pannello che si apre */}
                            <div className={`dropdown-content ${openDropdown === 'userMenu' ? 'open' : ''}`} style={{minWidth: '250px'}}>
                                
                                {/* 🎯 FIX: Link al Mio Profilo aggiunto nel menù utente */}
                                <div style={{padding: '5px 0'}}>
                                    <NavLink 
                                        to="/mio-profilo" 
                                        className="dropdown-link"
                                        onClick={() => setOpenDropdown(null)}
                                        style={({ isActive }) => isActive ? {backgroundColor: 'rgba(255,255,255,0.1)', fontWeight: 'bold'} : {}}
                                    >
                                        👤 Il Mio Profilo
                                    </NavLink>
                                </div>
                                <div style={{height: '1px', backgroundColor: '#555', margin: '8px 0'}} />

                                {/* Sezione Switch Centro (mostra solo se c'è più di 1 centro) */}
                                {Object.keys(availableCenters).length > 1 && (
                                    <>
                                        <div style={{padding: '10px 16px 5px', fontSize: '0.8rem', color: '#999', textTransform: 'uppercase'}}>Cambia Centro</div>
                                        {Object.keys(availableCenters).map(centerId => (
                                            <a // Usiamo <a> o <button> invece di NavLink
                                                key={centerId}
                                                href="#"
                                                className="dropdown-link"
                                                // Stile speciale per il centro attivo
                                                style={centerId === activeCenterId ? {backgroundColor: 'rgba(255,255,255,0.1)', fontWeight: 'bold'} : {}}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    switchCenter(centerId);
                                                    setOpenDropdown(null); // Chiudi menu
                                                }}
                                            >
                                                {centerId.replace(/-/g, ' ')}
                                                {centerId === activeCenterId && ' (Attivo)'}
                                            </a>
                                        ))}
                                        <div style={{height: '1px', backgroundColor: '#555', margin: '8px 0'}} /> {/* Separatore */}
                                    </>
                                )}
                            </div>
                        </div>

                        {/* 🤖 AURA COPILOT (Inserito QUI: Tra Switch Centro e Navigazione Home) */}
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <AuraCopilotWidget />
                        </div>

                    </div>
                                        
                    {/* Gruppo Centrale: Link Navigazione (invariato) */}
                    <div className="nav-center-group">
<NavLink to="/" style={({ isActive }) => isActive ? { ...navLinkStyle, ...activeNavLinkStyle } : navLinkStyle} onClick={() => setOpenDropdown(null)}>Home</NavLink>
                        {navStructure.map(item => {
                            // ... (logica invariata per 'dropdown' e 'link')
                            if (item.type === 'dropdown') {
                                
                                // 🎯 FIX CHIRURGICO MEDICI: Uccidiamo l'intero menù Gestione alla radice
                                if (userProfile?.isDoctorProfile) return null;

                                // --- INIZIO MODIFICA: Permesso 'shiftRules' ---
                                const canViewAnySubItem = item.subItems.some(sub => {
                                    const subPerm = userProfile.permissions[sub.key] || 'none';
                                    if (sub.key === 'payroll') {
                                        return subPerm === 'completo' || subPerm === 'semi-completo';
                                    }
                                    if (sub.key === 'shiftRules') {
                                        // Lega questo permesso a chi può modificare i turni
                                        const shiftPerm = userProfile.permissions['shifts'] || 'none';
                                        return shiftPerm === 'completo' || shiftPerm === 'semi-completo';
                                    }
                                    return subPerm !== 'none';
                                });
                                // --- FINE MODIFICA ---
                                if (!canViewAnySubItem) return null;
                                const isOpen = openDropdown === item.key;
                                return (
                                    <div key={item.key} className="nav-dropdown">
                                        <button
    className="dropdown-button"
    style={isOpen ? { ...navLinkStyle, ...activeNavLinkStyle } : navLinkStyle}
    onPointerDown={(e) => {
        e.stopPropagation();
        setOpenDropdown(isOpen ? null : item.key);
    }}
>
                                            {item.label}
                                        </button>
                                        <div className={`dropdown-content ${isOpen ? 'open' : ''}`}>
                                            {item.subItems.map(subItem => {
                                                // --- INIZIO MODIFICA: Logica permessi sub-item ---
                                                const subPerm = userProfile.permissions[subItem.key] || 'none';
                                                let canViewSub = subPerm !== 'none';
                                                
                                                if (subItem.key === 'payroll') {
                                                    canViewSub = subPerm === 'completo' || subPerm === 'semi-completo';
                                                }
                                                if (subItem.key === 'shiftRules') {
                                                    const shiftPerm = userProfile.permissions['shifts'] || 'none';
                                                    canViewSub = shiftPerm === 'completo' || shiftPerm === 'semi-completo';
                                                }

                                                // 🎯 FIX MEDICI: Nascondi voci vietate, forza 'stanze'
                                                if (userProfile.isDoctorProfile) {
                                                    if (['shifts', 'timelogs', 'leaves', 'payslips', 'payroll', 'staff', 'centerManagement', 'procedures'].includes(subItem.key)) return null;
                                                    if (subItem.key === 'rooms') canViewSub = true;
                                                }
                                                // --- FINE MODIFICA ---
                                                
                                                return canViewSub && (
                                                    <NavLink
                                                        key={subItem.key}
                                                        to={subItem.path}
                                                        className="dropdown-link"
                                                        style={({ isActive }) => isActive ? activeNavLinkStyle : {}}
                                                        onClick={() => setOpenDropdown(null)}
                                                    >
                                                        {subItem.label}
                                                    </NavLink>
                                                );
                                            })}
                                        </div>
                                    </div>
                                );
                            }

                            // --- CASO 2: LINK SINGOLO ---
                            if (item.type === 'link') {
                                const perm = userProfile.permissions[item.key] || 'none';
                                let canView = perm !== 'none';
                                if (item.key === 'payroll') {
                                    canView = perm === 'completo' || perm === 'semi-completo';
                                }

                                // 🎯 FIX MEDICI: Nascondi voci vietate, forza 'stanze' e 'compensi'
                                if (userProfile.isDoctorProfile) {
                                    if (['shifts', 'timelogs', 'leaves', 'payslips', 'payroll', 'staff', 'centerManagement', 'procedures'].includes(item.key)) return null;
                                    if (item.key === 'rooms' || item.key === 'myCompensations') canView = true;
                                }
                                
                                return canView && (
                                    <NavLink 
                                        key={item.key} 
                                        to={item.path} 
                                        style={({ isActive }) => isActive ? { ...navLinkStyle, ...activeNavLinkStyle } : navLinkStyle}
                                        onClick={() => setOpenDropdown(null)}
                                    >
                                        {item.label}
                                    </NavLink>
                                );
                            }
                            return null; // Fallback
                        })}
                    </div>
                    {/* --- FINE MODIFICA LOGICA NAV --- */}
                    
                    <div className="nav-right-group" style={{ flex: '1', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '5px', minWidth: '150px' }}> {/* flex: 1 bilancia il lato sinistro, larghezza minima */}
                        {/* --- NUOVO PULSANTE BACHECA --- */}
                        <button
                            className="sticky-notes-toggle-btn desktop-only"
                            onClick={() => navigate('/bacheca')}
                            title="Bacheca Avvisi"
                         >
                            <span className="dashboard-icon-large" role="img" aria-label="Bacheca">📢</span>
                        </button>
                        {/* ------------------------------ */}
                        <button
                            className="sticky-notes-toggle-btn desktop-only"
                            onClick={() => setIsCalendarPanelOpen(true)}
                            title="Calendario Rapido"
                         >
                            <span className="dashboard-icon-large" role="img" aria-label="Calendario Rapido">📅</span>
                        </button>
                        <button
                            className="sticky-notes-toggle-btn desktop-only"
                            onClick={() => setIsStickyNotesOpen(true)}
                            title="Note Rapide"
                         >
                            <span className="dashboard-icon-large" role="img" aria-label="Note Rapide">📝</span>
                        </button>
                        <div style={notificationWrapperStyle}>
                            <button style={notificationButtonStyle} onClick={() => setIsPanelOpen(p => !p)}>🔔{unreadCount > 0 && <span style={unreadBadgeStyle}>{unreadCount}</span>}</button>
                            {isPanelOpen && <NotificationsPanel notifications={notifications} onClose={() => setIsPanelOpen(false)} />}
                        </div>
                        <button onClick={handleLogout} style={logoutButtonStyle}><img src="/LOGOUT.png" alt="Logout" width={25} height={25} /></button>
                    </div>
                </div>
                
                {/* --- Wrapper Mobile (la logica è nel componente MobileMenu ora) --- */}
                <div className="nav-mobile-wrapper">
                     {/* ⭐ MODIFICA 1: NASCONDI TOTALMENTE LA BARRA UTENTE/CENTRO ⭐ */}
                     <div className="nav-left-group" style={{display: 'none !important'}}>
                        <span style={{ ...userNameStyle, fontSize: '0.8rem' }}>
                            {userProfile.name}
                            <span style={{opacity: 0.7, marginLeft: '5px'}}>({activeCenterId.replace(/-/g, ' ')})</span>
                        </span>
                    </div>
                    {/* ⭐ FINE MODIFICA 1 ⭐ */}

                    <div className="nav-center-group">
                        <NavLink to="/" style={({ isActive }) => isActive ? { ...navLinkStyle, ...activeNavLinkStyle } : { ...navLinkStyle, padding: '8px 10px' }}>Home</NavLink>
                        {/* 🎯 FIX MEDICI: Mostriamo Turni solo se l'utente non è medico e ha permessi */}
                        {(!userProfile.isDoctorProfile && (userProfile.permissions?.shifts && userProfile.permissions.shifts !== 'none')) && (
                            <NavLink to="/turni" style={({ isActive }) => isActive ? { ...navLinkStyle, ...activeNavLinkStyle } : navLinkStyle}>Turni</NavLink>
                        )}
                    </div>
                    <div className="nav-right-group">
                        <div style={notificationWrapperStyle}>
                             <button style={notificationButtonStyle} onClick={() => setIsPanelOpen(p => !p)}>🔔{unreadCount > 0 && <span style={unreadBadgeStyle}>{unreadCount}</span>}</button>
                            {isPanelOpen && <NotificationsPanel notifications={notifications} onClose={() => setIsPanelOpen(false)} />}
                        </div>
                        <button onClick={handleLogout} style={logoutButtonStyle}><img src="/LOGOUT.png" alt="Logout" width={25} height={25} /></button>
                        <button className="hamburger-button" onClick={() => setIsMobileMenuOpen(true)}>☰</button>
                    </div>
                </div>
            </nav>
            <StickyNotesPanel isOpen={isStickyNotesOpen} onClose={() => setIsStickyNotesOpen(false)} />
                <CalendarPanel isOpen={isCalendarPanelOpen} onClose={() => setIsCalendarPanelOpen(false)} />
            <Routes>
               <Route path="/" element={<Dashboard />} />
               {/* 🎯 NUOVA ROTTA: Il Mio Profilo (Puntiamo a ManageDoctors) */}
               <Route path="/mio-profilo" element={<ManageDoctors isProfileMode={true} />} />
               {/* 🎯 NUOVA ROTTA: I Miei Compensi (Solo per i medici) */}
               <Route path="/miei-compensi" element={
                   userProfile?.isDoctorProfile ? <MyCompensations /> : <Navigate to="/" replace />
               } />

               <Route path="/turni" element={<ProtectedRoute pageKey="shifts"><ShiftsPage /></ProtectedRoute>} />
               <Route path="/personale" element={<ProtectedRoute pageKey="staff"><ManageStaff /></ProtectedRoute>} />
               <Route path="/profili-contrattuali" element={<ProtectedRoute pageKey="staff"><ManageContractProfiles /></ProtectedRoute>} />
               <Route path="/procedure" element={<ProtectedRoute pageKey="procedures"><ProceduresPage /></ProtectedRoute>} />
               <Route path="/calendario" element={<ProtectedRoute pageKey="calendar"><CalendarPage /></ProtectedRoute>} />
               <Route path="/assenze" element={<ProtectedRoute pageKey="leaves"><LeaveManagementPage /></ProtectedRoute>} />
               {/* 🎯 FIX MEDICI: Stanze visibile sia a chi ha permessi sia ai medici */}
               <Route path="/stanze" element={
                   (userProfile?.permissions?.rooms !== 'none' || userProfile?.isDoctorProfile) 
                   ? <RoomsPage /> 
                   : <Navigate to="/" replace />
               } />

               <Route path="/inventario" element={<ProtectedRoute pageKey="inventory"><ManageInventory /></ProtectedRoute>} />
               <Route path="/timbrature" element={
                   // Usa la chiave permesso definita in appConfig
                   <ProtectedRoute pageKey="timelogs">
                       <TimesheetView />
                   </ProtectedRoute>
               } />
               {/* --- 2. AGGIUNGI LA NUOVA ROUTE PER LE PAGHE --- */}
               <Route path="/paghe" element={
                   <ProtectedRoute pageKey="payroll">
                       <PayrollDashboard />
                   </ProtectedRoute>
               } />
               {/* --- FINE --- */}
               {/* --- INIZIO MODIFICA 3: Aggiungi la nuova rotta --- */}
               <Route path="/buste-paga" element={
                   <ProtectedRoute pageKey="payslips">
                       <PayslipPage />
                   </ProtectedRoute>
               } />
               {/* --- NUOVA ROTTA: Note Spesa --- */}
               <Route path="/note-spesa" element={
                   <ProtectedRoute pageKey="expenseNotes">
                       <ExpenseNotesPage />
                   </ProtectedRoute>
               } />
               {/* --- INIZIO MODIFICA: Aggiunta rotta Calcolo Turni --- */}
               <Route path="/calcolo-turni" element={
                   // Proteggiamo la pagina usando il permesso 'shifts' (o 'shiftRules' se lo preferisci)
                   <ProtectedRoute pageKey="shifts"> 
                       <ShiftRulesPage />
                   </ProtectedRoute>
               } />
               {/* --- FINE MODIFICA --- */}
               <Route path="/gestione-centro" element={
                   <ProtectedRoute pageKey="centerManagement">
                       <ManageCenter />
                   </ProtectedRoute>
               } />
               <Route 
  path="/logs" 
  element={
    <ProtectedRoute requiredPermission="admin"> {/* O il permesso che preferisci, es. "staff" level completo */}
      <ActivityLog />
    </ProtectedRoute>
  } 
/>
               <Route path="/reports" element={<ProtectedRoute pageKey="reports"><ReportsPage /></ProtectedRoute>} />
               <Route path="/bacheca" element={<ProtectedRoute pageKey="announcements"><Announcements /></ProtectedRoute>} />
               <Route path="/admin" element={<ProtectedRoute pageKey="adminDashboard"><AdminDashboard /></ProtectedRoute>} />
               <Route path="/login" element={<Navigate to="/" replace />} />
               <Route path="/register" element={<Navigate to="/" replace />} />
               {/* --- FINE MODIFICA 3 --- */}
               <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </div>
    );
}

function App() {
    return (
        // 👇 AVVOLGO TUTTO NEL QUERY CLIENT PROVIDER
        <QueryClientProvider client={queryClient}>
            <UserProvider>
                <BillingProvider>
                    <AppContent />
                </BillingProvider>
            </UserProvider>
        </QueryClientProvider>
    );
}

export default App;
